import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import central, { FormatoData } from '../api/Central';
import Resultado from '../api/Resultado.js';
import Alert from '../components/Alert.js';
import Error from '../components/Error.js';
import Navegacao from '../components/Navegacao.js';

const Chamado = (props) => {
  var item = props.chamado;
  var lnk = "/chamados/" + item.id;
  return (<React.Fragment>
    <tr>
      <td>{FormatoData.format(item.dataabertura)}</td>
      <td>{item.queixa}</td>
      <td>{item.status}</td>
    </tr>
  </React.Fragment>)
};

class Chamados extends Component {

  constructor(props) {
    super(props);
    this.state = {
      chamados: { rows: [] },
      disabled: false,
      erro: null,
      carregado: true
    }
  }

  redireciona() {
    this.props.history.push("/login");
  }

  carrega() {
    this.setState({ carregando: true });
    central.requestAndCatch(
      "GET",
      "/chamados" + (this.props.conta ? "?conta=" + this.props.conta.idconta : ""),
      null,
      (payload) => {
        var chamados = new Resultado(payload);
        this.setState({ chamados: chamados, carregado: true });
      },
      (msg) => {
        this.setState({ erro: "Erro ao consultar chamados: " + msg });
      },
      () => {
        this.setState({ carregando: false });
      });

  }

  componentDidMount() {
    this.carrega();
  }

  render() {
    var tabela = (<table>
      <thead>
        <tr>
          <th>Vencimento</th>
          <th>Descrição</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {this.state.chamados.rows.map((chamado) => <Chamado key={chamado.id} chamado={chamado} />)}
      </tbody>
    </table>);

    var msgVazio;
    if (this.props.conta) {
      msgVazio = "Não existe nenhum chamado cadastrado para este serviço.";
    } else {
      msgVazio = "Não existe nenhum chamado avulso.";
    }

    var cabecalho = null;
    if (this.props.conta) {
      cabecalho = (
        <div className="boletos_cabecalho">
          <div className="boletos_cabecalho_titulo">SERVIÇO {this.props.conta.idconta} {!this.props.conta.ativo && "[INATIVO]"}- Vencimento dia {this.props.conta.diavencimento}</div>
          <div className="boletos_cabecalho_subtitulo">
            {this.props.conta.inst_logradouro}
            {this.props.conta.inst_numero ? ", " + this.props.conta.inst_numero : "S/N"}
            {this.props.conta.inst_complemento ? ", " + this.props.conta.inst_complemento : ""}
          </div>
          <div className="boletos_cabecalho_subtitulo">
            {this.props.conta.inst_bairro}
            {this.props.conta.inst_cidade 
            ? (this.props.conta.inst_bairro ? ", " : "") 
            + this.props.conta.inst_cidade + " - " + this.props.conta.inst_estado
            : "" }          
          </div>
        </div>);
      } else if (this.state.chamados.rows.length > 0) {
      cabecalho = (<div className="chamados_cabecalho">Chamados avulsos:</div>);
    }


    var vazio = (<Alert type="info">{msgVazio}</Alert>);

    var erro = (<Error msg={this.state.erro} disabled={this.state.carregando} onButtonClick={this.carrega.bind(this)} buttonLabel="Tentar Novamente" />);

    var loader = (<Alert type="info">Carregando...</Alert>);


    var componente = null;
    if (this.state.carregando) {
      componente = loader;
    } else if (this.state.erro) {
      componente = erro;
    } else if (this.state.chamados.rows.length > 0) {
      componente = tabela;
    } else if (this.props.conta) {
      componente = vazio;
    }

    return (
      ((this.props.conta && this.props.conta.ativo) || this.state.chamados.rows.length > 0) ? <section>
          {cabecalho}
          {componente}
        </section> : <div />

    );
  }
}

class Servico extends Component {
  render() {

    return (
      <React.Fragment>
        <Chamados conta={this.props.conta} />
      </React.Fragment>
    );
  }
}

class Servicos extends Component {

  constructor(props) {
    super(props);
    this.state = {
      carregando: false,
      erro: null,
      contas: { rows: [] }
    }
  }

  carrega() {
    central.listaContas((resultado) => {
      this.setState({ contas: resultado });
    },
      (msgErro) => {
        this.setState({ erro: msgErro });
      },
      () => {
        this.setState({ carregando: false });
      }
    );
  }

  componentDidMount() {
    this.carrega();
  }

  render() {

    return (
      <section className="container">
        <Navegacao link="/" titulo="Meus Chamados" />
        <section>
          {this.state.contas.rows.length > 1 && (<Alert type="info">Observação: Seu cadastro possui {this.state.contas.rows.length} serviços contratados. Os chamados abaixo estão separados por serviço.</Alert>)}
          {this.state.contas.rows.map((row) => {
            return (<Servico key={row.idtr} conta={row} />);
          })}
        </section>
        <section className="acoesPosLista">
          <Link className="button" to="/chamados/novo">Abrir novo chamado</Link>
        </section>
      </section>

    );

  }
}

export default Servicos;